const childrenLoaded = require('@alexspirgel/children-loaded');

class ComponentTestimonial extends HTMLDivElement {

	constructor() {
		super();
	}

	async connectedCallback() {
		await childrenLoaded(this);
		this.initialize();
	}

	initialize() {
		if (this.initialized) {
			return;
		}

    let sliders = document.querySelectorAll('.splide');

    if (!sliders.length) {
      return;
    }

    sliders.forEach(slider => {
      const splide = new Splide(slider, {
        type  : 'fade',
        rewind: true,
        perPage    : 1,
        perMove    : 1,
        pagination : false,
        arrows     : slider.getAttribute('data-has-pager') == 1,
        focus      : 'center',
        gap        : '1rem',
        breakpoints: {
          768: {
            perPage: 2,
            gap    : '2rem',
          },
          1024: {
            perPage: 3,
            gap    : '3rem',
          },
        },
      }).mount();

      splide.on('move', function (newIndex, prevIndex, destIndex) {
        document.querySelector('div[data-active-image="' + newIndex + '"]').classList.add('active');
        document.querySelector('div[data-active-image="' + prevIndex + '"]').classList.remove('active');
        document.querySelector('.component-testimonial__current-page').textContent = newIndex + 1;
      });
    });

    this.initialized = true;
	}

}

customElements.define('component-testimonial', ComponentTestimonial, {extends: 'div'});